var map = {
	"./add-student.vue": [
		"L9zD",
		5
	],
	"./banner-info.vue": [
		"vRsx",
		17
	],
	"./commission.vue": [
		"hZPa",
		0,
		11
	],
	"./data-collection.vue": [
		"PVBC",
		0,
		4
	],
	"./debug.vue": [
		"YFtO",
		0,
		7
	],
	"./electrical.vue": [
		"6YgC",
		0,
		9
	],
	"./equipment-preservation.vue": [
		"ZeIJ",
		0,
		10
	],
	"./mechanical.vue": [
		"yigC",
		0,
		6
	],
	"./open-class.vue": [
		"9Ffb",
		12
	],
	"./technical.vue": [
		"l1oO",
		0,
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Ov3z";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/znc-school/course-info lazy ^\.\/.*\.vue$
// module id = Ov3z
// module chunks = 24